import { HiringFilterComp, JobCardComp } from '@/components';
import { GlobalContext } from '@/context';
import { API } from '@/data';
import { RestAPI } from '@/scripts';
import { __HiringSortList } from '@/tehranto/hiringList/hiringList.data';
import { __HiringCheckFilterChange, __HiringFetchParams } from '@/tehranto/hiringList/hiringList.script';
import { HiringCategoryType, HiringType, PaginationType } from '@/types';
import { Button, Empty, message, Pagination, Select, Spin } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { BiSortAlt2 } from 'react-icons/bi';
import { TbFilter } from 'react-icons/tb';
import { __BrandDetailPath } from '../brandDetail.scripts';
import { __BrandSectionEnum } from '../brandDetail.type';
import styles from './hiring.module.scss';
import { __BrandHiringPropsType } from './hiring.type';
export default function BrandHiringComp(props: __BrandHiringPropsType) {
  const {
    langText
  } = useContext(GlobalContext);
  const filters = props.filters;
  const [jobs, setJobs] = useState(props.hiring);
  const [categories, setCategories] = useState(props.categories);
  const lang = langText.hiring;
  const [isOpen, setIsOpen] = useState(false);
  const onJobCardChange = (e: HiringType, index: number) => {
    setJobs(jobs => jobs ? {
      ...jobs,
      data: [...jobs.data.slice(0, index), e, ...jobs.data.slice(index + 1)]
    } : undefined);
  };
  const orderedHandler = (title: string) => {
    if (filters.order !== title) props.setFilters({
      ...filters,
      order: title
    });
  };
  useEffect(() => {
    if (!categories) RestAPI.get<PaginationType<HiringCategoryType>>(API.hiring.categories, {
      page_size: 100
    }).then(res => setCategories(res.data.data));
  }, []);
  useEffect(() => {
    const path = __BrandDetailPath(filters, langText.lang, props.data.slug);
    window.history.replaceState(null, '', path);
    const descriptionMetaTag: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (descriptionMetaTag) descriptionMetaTag.href = path.href;
    if (props.hiring && __HiringCheckFilterChange(filters, props.initialFilters)) setJobs(props.hiring);else {
      const newParams = __HiringFetchParams(filters, langText.lang, props.data.slug);
      setJobs(undefined);
      RestAPI.get<PaginationType<HiringType>>(API.hiring.index, newParams).then(res => setJobs(res.data)).catch(() => message.error(langText.general.error));
    }
  }, [filters]);
  return <div className={`main-content gap-16 ${styles['hiring']}`} data-sentry-component="BrandHiringComp" data-sentry-source-file="hiring.index.tsx">
            <HiringFilterComp filters={filters} setFilters={e => props.setFilters(Object.keys(e).length ? e : {
      section: __BrandSectionEnum.hiring
    })} isOpen={isOpen} setIsOpen={setIsOpen} categories={categories} data-sentry-element="HiringFilterComp" data-sentry-source-file="hiring.index.tsx" />
            <div className="flex-1">
                <div className={`d-lg-none justify-content-between align-items-center gap-16 mb-2`}>
                    <Button onClick={() => setIsOpen(true)} type="primary" className="d-none-i d-pre-lg-flex-i gap-8 w-100 center-content-x" data-sentry-element="Button" data-sentry-source-file="hiring.index.tsx">
                        <TbFilter size={15} data-sentry-element="TbFilter" data-sentry-source-file="hiring.index.tsx" /> {lang.filters}
                    </Button>
                    <Select placeholder={lang.ordering} className="d-none-i d-pre-lg-flex-i w-100 text-center" suffixIcon={<BiSortAlt2 size={20} />} options={__HiringSortList(lang)} onChange={orderedHandler} value={filters?.order ?? null} data-sentry-element="Select" data-sentry-source-file="hiring.index.tsx" />
                </div>
                <div className={`align-items-center justify-content-between d-pre-lg-none mb-2`}>
                    <div className="align-items-center flex-wrap gap-24">
                        <p className="t-500 t-dark1 t-p1">{lang.ordering}:</p>
                        <div className="align-items-center flex-wrap gap-12">
                            {__HiringSortList(lang).map(item => <span onClick={() => orderedHandler(item.slug)} key={item.slug} className={`t-p1 t-400 t-${filters.order === item.slug ? 'primary' : 'dark3'} pointer`}>
                                    {item.title}
                                </span>)}
                        </div>
                    </div>
                    <span className="t-p1 t-400 t-dark3 d-block">
                        {jobs?.count} {lang.result}
                    </span>
                </div>
                {jobs ? jobs.count ? <>
                            <div className={`flex-column gap-16`}>
                                {jobs.data.map((item, index) => <JobCardComp key={index} data={item} onChange={e => onJobCardChange(e, index)} />)}
                            </div>
                            <div className={`${styles['pagination-layout']} ${(jobs?.num_of_pages ?? 0) > 1 ? '' : 'd-none'} center-content mt-6`}>
                                <div className={`${styles['pagination']} center-content`}>
                                    <Pagination size="small" current={filters.page ? Number(filters.page) : 1} pageSize={5} total={jobs?.count} showSizeChanger={false} hideOnSinglePage onChange={e => props.setFilters({
              ...filters,
              page: e.toString()
            })} />
                                </div>
                            </div>
                        </> : <Empty className="mt-8" description={lang.emptyHiring} /> : <div className="w-100 pv-6 center-content">
                        <Spin />
                    </div>}
            </div>
        </div>;
}